import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  font-family: ${({ theme }) => theme.font.quinary};
  h1 {
    text-align: left;
    color: ${({ theme }) => theme.neutral.gray[1300]};
  }
  background-color: ${({ theme }) => theme.neutral.white};
`;
